import { render, staticRenderFns } from "./companyProperty.vue?vue&type=template&id=2560f7e8"
import script from "./companyProperty.vue?vue&type=script&lang=js"
export * from "./companyProperty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports